module.exports = __webpack_public_path__ + "static/media/DRIVETECHPRO.2c5da74c.pdf";